import {useMessages} from "i18n";

/**
 * Data Deletion Instructions content (ui#185). Thin wrapper that renders the active locale's
 * title-free body from the catalog (`messages.legal.dataDeletion`, defined in
 * `src/i18n/richText.*.tsx`). The owning route supplies the single document title.
 *
 * Mirrors {@link ./PrivacyPolicy} exactly: default export, NO props — so the body can gain a second
 * surface (a Resources dialog) later without changing its contract.
 */
export default function DataDeletion() {
	return useMessages().legal.dataDeletion();
}
